import { useMemo } from 'react'

import { AgChartProps } from 'ag-charts-react'

import { CustomAgChart } from '@fortem-monorepo/react-ag'

import { ICReportChartPrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { fundLevel } from '@/react-query/queries/ic-report/hooks'

export interface RebasedNavChartProps extends ICReportChartPrimitive {}

export const RebasedNavChart: React.FC<RebasedNavChartProps> = ({ params, options }) => {
  const query = fundLevel.useRebasedNav(params)
  const data = query.data ?? []

  const dataFormatted = useMemo(() => {
    return data.map((data: any) => ({
      ...data,
      date: new Date(data.date),
    }))
  }, [data])

  const mergedOptions: AgChartProps['options'] = {
    data: dataFormatted,
    series: Object.keys(dataFormatted?.[0] ?? {})
      .filter((key) => !['date'].includes(key))
      .map((key) => ({
        type: 'line',
        xKey: 'date',
        yKey: key,
        marker: {
          size: 0,
        },
      })),
    axes: [
      {
        type: 'time',
        nice: false,
        position: 'bottom',
        label: {
          format: '%d %b %Y ',
        },
      },
      {
        type: 'number',
        position: 'left',
      },
    ],
    ...options,
  }

  return <CustomAgChart options={mergedOptions} />
}
